import React from 'react';

interface OwnProps {
  title?: string;
  active?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Text button used in the editor toolbar.
 *
 * Styling lives in `styles.css` under `.editor-toolbar button.tool-btn`
 * because the button is styled within the toolbar context.
 */
const ToolButton = ({ title, active, disabled, children, onClick }: OwnProps) => (
  <button
    type='button'
    onClick={onClick}
    className={`tool-btn${active ? ' active' : ''}`}
    title={title}
    disabled={disabled}
  >
    {children}
  </button>
);

const MemoToolButton = React.memo(ToolButton);

export { MemoToolButton as ToolButton };
export default MemoToolButton;
